<wai-alert [type]="data.type" [persistent]="false">{{ data.message }}</wai-alert>
